<!--
 * @Description: 巡检记录 详情
 * @Author: PF
 * @Date: 2023-12-27 11:22:28
 * @LastEditors: PF
 * @LastEditTime: 2024-05-29 09:18:34
-->

<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-input placeholder="巡检内容与标准" v-model="dataGrid.parms.xjnrybz" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="巡检内容与标准" prop="xjclmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="巡检频率" prop="xjpl.name" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="位置" prop="wz" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="必须拍照" prop="bxpz" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-if="scope.row.sfbxpz==true">是</span>
                  <span v-if="scope.row.sfbxpz==false">否</span>
                </template>
                </el-table-column>
              <el-table-column label="检查情况" prop="wcclzt.name" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="图片" prop="tp" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-image class="avatar" v-if="scope.row.xgfj" style="width: 100%; height: 100px" :src="baseurl + scope.row.xgfj" fit="contain" />
                </template>
              </el-table-column>
              <el-table-column label="是否正常" prop="" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <div v-if="scope.row.wcclzt.value==9">
                    <span v-if="scope.row.sfzc==true">正常</span>
                    <span v-if="scope.row.sfzc==false">异常</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="描述" prop="ms" align="center" show-overflow-tooltip />
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, closeWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'

const props = defineProps({
  openDetail: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])

const baseurl = ref(process.env.VUE_APP_BASE_API)

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'jsxjsj', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/pinganxiaoyuan/xunjiancelue/xunjianjilu/xunjianjilumxlist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value
  })
}

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      dataGrid.value.parms.xjjlid = props.row.id
      bindTable()
    }
  },
  { deep: true, immediate: true }
)

</script>
